(ns superadmin.malware-scans.view
  (:require ["@mui/material/Tooltip$default" :as Tooltip]
            ["@mui/material/Typography$default" :as Typography]
            ["@mui/x-data-grid-premium" :refer [DataGridPremium GridActionsCellItem]]
            [cljs-bean.core :refer [->js]]
            [common.modal.view :refer [confirmation-modal defmodal]]
            [common.queries :refer [use-mutation use-query]]
            [common.widgets.page :as page]
            [re-frame.core :as rf]
            [superadmin.malware-scans.queries :as q]
            [uix.core :refer [$ as-react defui]]))

(defmodal confirm-blocking :malware-scans/confirm-blocking
  [{:keys [block-fn]}]
  ($ confirmation-modal {:title "Adset blocking"
                         :confirm-details "Adset will be blocked from ad-serving."
                         :action-fn block-fn}))

(defn action-column
  []
  #js {:type "actions"
       :field "actions"
       :headerName "Blocking"
       :selectable false
       :getActions (as-react
                    (fn [^js params]
                      (let [{block-adset :mutate} (use-mutation (q/block-adset-mutation))
                            {activate-adset :mutate} (use-mutation (q/activate-mailware-job-mutation))
                            job (-> params :row)
                            adset-blocked? (:adset-blocked job)
                            block-fn (fn [] (block-adset [(:adset-id job) (not adset-blocked?)]))
                            block-action ($ GridActionsCellItem
                                            {:label (if adset-blocked? "Unblock adset" "Block adset")
                                             :showInMenu true
                                             :onClick #(if adset-blocked?
                                                         (block-fn)
                                                         (rf/dispatch
                                                          [:modal/open {:id :malware-scans/confirm-blocking
                                                                        :props {:block-fn block-fn}}]))})
                            initialized? (:initialized-at job)
                            activate-action ($ GridActionsCellItem
                                               {:label "Reinitialize job"
                                                :showInMenu true
                                                :onClick #(activate-adset (:id job))})]
                        (if initialized?
                          #js [block-action]
                          #js [block-action activate-action]))))})

(defn derive-status
  [job]
  (let [initialized? (:initialized-at job)
        was-attempted? (:initialization-attempted-at job)]
    (if initialized?
      "Running"
      (if was-attempted?
        "Initialization failed"
        "Pending"))))

(defn clean-tmt-response
  [job]
  (if-not (:initialized-at job)
    (str (get-in job [:initialization-response :status]) " :: " (get-in job [:initialization-response :body]))
    "OK"))

(defn column
  [c-name tag type props]
  (let [default-column  {:type "string"
                         :field (name tag)
                         :headerName c-name
                         :valueGetter (fn [_ row _ _]
                                        (tag row))
                         :renderCell (fn [^js params]
                                       (str (.-value params)))
                         :flex 1
                         :width 20
                         :sortable true
                         :filterable true}]
    (->> (case type
           :block-status {:valueGetter (fn [_ row _ _]
                                         (let [blocked? (tag row)]
                                           (if blocked?
                                             {:title "Blocked"
                                              :at (-> row :adset-blocked-at js/Date. str)}
                                             {:title "Not Blocked"
                                              :at (-> row :adset-unblocked-at js/Date. str)})))
                          :renderCell (fn [^js params]
                                        (let [tooltip (-> (.-value params) :at)
                                              value (-> (.-value params) :title)]
                                          ($ Tooltip
                                             {:placement :bottom
                                              :title tooltip}
                                             ($ Typography value))))}
           :date {:renderCell (fn [^js params]
                                (some-> (.-value params) js/Date. str))}
           :status {:valueGetter (fn [_ row _ _]
                                   (derive-status row))}
           :tmt-response {:valueGetter (fn [_ row _ _]
                                         (clean-tmt-response row))}
           nil)
         (merge default-column props)
         ->js)))

(defn get-columns [defs]
  (->js
   (conj
    (mapv #(apply column %) defs)
    (action-column))))

(defn columns []
  (get-columns [["Agency" :agency-name]
                ["Advertiser" :advertiser-name]
                ["Campaign" :campaign-name]
                ["Adset" :adset-name]
                ["User" :user-name]
                ["User email" :user-email]
                ["Tag name" :tag-name]
                ["Tag" :tag :tag]
                ["Adset status" :adset-blocked :block-status]
                ["Scan status" :status :status]
                ["Created at" :created-at :date]
                ["Initialization attempted at" :initialization-attempted-at :date]
                ["Initialized at" :initialized-at :date]
                ["Initialization response" :initialization-response :tmt-response]]))

(defui malware-table
  []
  (let [{:keys [data isFetching]} (use-query (q/malware-scans-all))]
    ($ Typography "Malware table")
    ($ DataGridPremium
       {:columns (columns)
        :loading isFetching
        :rows (to-array (:data data))
        :getRowId #(:id %)
        :disableRowSelectionOnClick true
        :initialState #js {:sorting #js {:sortModel #js [#js {:field "agency-name" :sort "asc"}]}}})))

(defn malware-scans-page []
  ($ page/page
     ($ page/page-header
        {:title "Malware Scans"})
     ($ page/content-padding
        ($ malware-table))))
